import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import { BackendLink } from '../../../Components';
import './ProjectRightSide.css';

const ProjectRightSide = () => {
    const [randomProjects, setRandomProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await fetch(`${BackendLink}/AllProjects/`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();

                const shuffledProjects = [...data].sort(() => 0.5 - Math.random());
                const selectedProjects = shuffledProjects.slice(0, 3);
                setRandomProjects(selectedProjects);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProjects();
    }, []);

    return (
        <div>
            <h4 className="serRightMainTitle" data-aos="fade-up">
                Some of our Projects
            </h4>

            <div className="ProjectRightSide">
                {(loading || error || randomProjects.length === 0)
                    ? Array.from({ length: 3 }).map((_, i) => (
                        <div className="rightSide-skeleton-project-card" key={i}>
                            <Skeleton 
                                className='rightProjectImg-skeleton'
                                height={150} 
                                baseColor="var(--bg-footer)" 
                                highlightColor="var(--bg-body)" 
                            />
                            <Skeleton 
                                className='rightProjectTxt-skeleton'
                                height={10} 
                                baseColor="var(--bg-footer)" 
                                highlightColor="var(--bg-body)" 
                            />
                        </div>
                    ))
                    : randomProjects.map(({ id, projectImg, projectTitle }, index) => (
                        <Link 
                            to={`/Projects`} 
                            key={id} 
                            className="project-card"
                            data-aos="fade-up"
                            data-aos-delay={`${index}00`}
                        >
                            <div className="rightProjectImg-wrapper">
                                <img src={projectImg} alt={projectTitle} className="project-img" />
                            </div>
                            <h3 className="rightSideSerTitle">{projectTitle}</h3>
                        </Link>
                    ))
                }
            </div>
        </div>
    );
}

export default ProjectRightSide;
